import { useHistory } from 'react-router-dom'
import { NavigationProps } from '@resiliatech/birdsong'
import { useAppState } from 'Context/AppContext/AppContext'
import useConfigureActivePlans from 'Hooks/useConfigureActivePlans/useConfigureActivePlans'

const HOME_PATH = '/home'
export const useNavigationHeaderProps = (): Pick<
  NavigationProps,
  'platformPlan' | 'orgName' | 'logo' | 'isFunder'
> => {
  const history = useHistory()
  const { nonprofitOrgConfig, funderOrgConfig } = useAppState()
  const { platformPlan, orgName: nonprofitOrgName } = nonprofitOrgConfig
  const { orgName: funderOrgName } = funderOrgConfig
  const { isFunderUser } = useConfigureActivePlans()

  return {
    platformPlan: platformPlan || '',
    orgName: nonprofitOrgName || funderOrgName,
    logo: {
      handleClick: () => {
        history.push(HOME_PATH)
      },
      href: HOME_PATH,
    },
    isFunder: isFunderUser,
  }
}
